import { Box, Grid } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import {
  storeAllAssets,
} from "../../../redux/actions/AssetsManagement/Assets";
import { IState } from "../../../redux/reducers/rootReducers";
import CustomSeparator from "../../common2/Breadcrumbs";
import NoDataFound from "../../common2/NoDataFound";
import TopFilterNew from "../../common2/TopFilterNew";
import ContactLoader from "../../ContactsManagement/ContactLoader";
import { handleTime } from "../../helpers/helperFunctions";
import { GetAssetCSVreportsLazy } from "../../../redux/actions/AssetReport/assetReport";
import CommonCard from "./CommonCard";
import { DeleteIcon, EditIcon, EyeIcon } from "../../common/svgIcons/chartIcon";
import RestoreIcon from "../../../assest/icons/restore.svg";
import { StatusChangeCSVReport } from "../../../redux/actions/Reports/reports";

// import AssetCard from "./AssetCard";

const AssetsReportList = (props: any) => {
  const { csvAssetReport = [], addRolePermission, isSuperAdmin } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [hasMore, setHasMore] = useState<any>(true);
  const [page, setPage] = useState(0);
  const [filterValues, setFilterValues] = useState({
    search: "",
    isActive: true,
  });
  useEffect(() => {
    // console.log("pageNum: number", filterValues);
    setPage(0);
    dispatch(storeAllAssets([]));
    handleTime.cancel();
    handleTime.setup(() => {
      fetchAssets(0);
    });
  }, [filterValues]);
  useEffect(() => {
    fetchAssets();
  }, []);
  const getAssetCB = (pageNum: number, res: any, hasMoreAssets: boolean) => {
    setPage(pageNum + 1);
    setHasMore(hasMoreAssets);
    // console.log("pageNum: number", pageNum, page);
  };
  const fetchAssets = (pageNum?: number) => {
    // console.log("pageNum:", pageNum, page);
    handleTime.cancel();
    handleTime.setup(() => {
      const pageToSend =
        pageNum !== undefined && pageNum !== null ? pageNum : page;
      dispatch(
        GetAssetCSVreportsLazy(
          pageToSend,
          filterValues.isActive,
          filterValues.search,
          getAssetCB,
          50
        )
      );
    });
  };
  const filterCallback = (values: any) => {
    setFilterValues(values);
  };
  const addBtnHandler = useCallback(() => {
    navigate("/AssetsCSVReport");
  }, []);


  const list = csvAssetReport ? csvAssetReport.filter((item: any) => {
      return filterValues.isActive === item.isActive;
  }) : [];

  const softDelete = (id:number,isActive:boolean)=>{
      dispatch(StatusChangeCSVReport(id,isActive,StatusChangeCSVReportCB))
  }
  const StatusChangeCSVReportCB = (resStatus:"0"| "1",res:any,ids:number|string,isActive:boolean)=>{
    if(resStatus === "0"){
      dispatch({type:"UPDATE_ASSETS_CSV_REPORT_STATUS",payload: {id: ids, isActive: isActive} });
    }
  }
  return (
    <>
      <CustomSeparator
        data={[
          {
            title: "Reports Management ",
            path: "/ReportsManagement",
          },
          {
            title: "Asset Reports List",
            path: "/AssetsReportList",
          },
        ]}
      />
      <TopFilterNew
        callback={filterCallback}
        addHandler={addBtnHandler}
        backNavigationPath="/ReportsManagement"
        hideAddBtn={isSuperAdmin || addRolePermission ? false : true}
      />
      <Box className="pageHolder">
        {csvAssetReport?.length === 0 ? (
          <NoDataFound />
        ) : (
          <InfiniteScroll
            dataLength={list?.length}
            next={fetchAssets}
            hasMore={hasMore}
            loader={
              <>
                <ContactLoader />
              </>
            }
          >
            <Grid container className="pt-1" spacing={1}>
              {list?.map &&
                list?.map((item: any, index: number) => {
                  return (
                    <React.Fragment key={index}>
                      {/* <AssetCard {...item} /> */}
                      <CommonCard
                        cardClassName="contact-card"
                        bodyClassName="contact-card-body noFlex"
                        className="cardlist"
                        id={item.id}
                        title={item.name}
                        data={item}
                        dynamicFields={[
                          {
                            key: "name",
                            label: "Name",
                            value: item.name,
                          }
                        ]}
                        footerClassName="contact-card-footer"
                        actions={[
                          {
                            key: "Edit",
                            icon: <EditIcon />,
                            tooltip: "Edit Record",
                            onClick: () => navigate(`/AssetsCSVReport/${item.id}`),
                            show: (item: any) => item.isActive
                          },
                          {
                            key: "View",
                            icon: <EyeIcon />,
                            tooltip: "View Record",
                            onClick: () => navigate(`/ViewAssetsCSVReport/${item.id}`),
                            show: (item: any) => item.isActive
                          },
                          {
                            key: "Delete",
                            icon: <DeleteIcon />,
                            tooltip: "Delete Record",
                            onClick: () => softDelete(item.id,false),
                            show: (item: any) => item.isActive
                          },
                          {
                            key: "Restore",
                            icon:  <img src={RestoreIcon} alt="Delete icon" />,
                            tooltip: "Restore Record",
                            onClick: () => softDelete(item.id,true),
                            show: (item: any) => !item.isActive
                          }
                        ]}

                      />
                    </React.Fragment>
                  );
                })}
            </Grid>
          </InfiniteScroll>
        )}
      </Box>
    </>
  );
};
const mapStateToProps = (state: IState) => {
  return {
    addRolePermission: state?.LoginReducer?.roleAccess,
    csvAssetReport: state?.ReportsReducer?.csvAssetsReports,
    isSuperAdmin: state?.LoginReducer?.roleAccess?.isSuperAdmin,
  };
};

export default connect(mapStateToProps)(AssetsReportList);

// export default AssetsReportList;